function notif_browser(browser){
    if(browser == 'Firefox' || browser == 'Chrome' || browser == 'Opera'){
        return true;
    }else{
        return false;
    }
}

function notif_os(OS){
    if(OS == 'Linux' || OS == 'Mac OS X' || OS == 'Mac OS' || OS.charAt(0) == 'W' || OS == 'Android'){
        return true;
    }else{
        return false;
    }
}

function init_masthead_scroller()
{
    var didScroll = false;
    var lastScrollTop = 0;
    var delta = 5;
    var firedNewsletterPromo = 0; //INIT NEWSLETTER FIRED-TRIGGER
    var firedNotificationsPromo = 0; //INIT NOTIFICATIONS FIRED-TRIGGER


    if($('body.home').length>0){
        var navbarHeight = $("#masthead-container").outerHeight();
    }else{
        var navbarHeight = $("#masthead-wrapper").outerHeight();
    }

    // on scroll, let the interval function know the user has scrolled
    $(window).scroll(function(event){
        //console.info("Console: I am scrolling");
        didScroll = true;
    });

    // run hasScrolled() and reset didScroll status
    setInterval(function() {
        //console.info("didScroll @ top of interval: ", didScroll);
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
        //console.log("didScroll @ bottom after scrolling: ", didScroll);
    }, 500);

    function hasScrolled() {
        var st = $(window).scrollTop();
        var mastHeight = $("#masthead-wrapper").css("height");
        var mastheadContainerHeight = $("#masthead-container").css("height");

        var windowWidth = $(window).outerWidth();

        //notifications checks
        var n_browser = navigator.browserInfo.browser;
        var n_os = navigator.osInfo.os;
        var pop_up_notif = false;
        var notificationsPopCookie = readCookie('notificationsScrollPop');

        if(notif_browser(n_browser) && notif_os(n_os) &&
            SITE_INFO['name'] == "politics" && (!$("body").hasClass("home") && !$("body").hasClass("welcome")) && !notificationsPopCookie){
            pop_up_notif = true;
        }else if(notif_browser(n_browser) && notif_os(n_os) && SITE_INFO['name'] == "politics"
            && $('#notif_banner_content').is(':visible')){
            notif_banner_enabled = true;
        } else if($('#large_notif_content').is(':visible') || SITE_INFO['name'] != 'politics'){
            notif_banner_enabled = false;
        }

        if(notif_banner_enabled == false){
            $('#large_notif_content').slideUp();
            $('#container').css('padding-top', '0px');
            $('#masthead-container').css('margin-top', 'inherit');
            $('.flex-viewport').css('margin-top', 'inherit');
            if(SITE_INFO['name'] == "politics" && notif_banner_enabled == true){
                switch_to_banner(windowWidth);
            }
        }

        //end notifications checks

        //if(Math.abs(lastScrollTop-st) <= delta) return;

        // If current position > last position AND scrolled past navbar...
        //console.log(st+' > '+navbarHeight);
        //if (st > lastScrollTop && st > navbarHeight){ EM: Original
        if (st > lastScrollTop && st > 1){

            //checks viewport vertical scroll percentage
            var scrollPercentage = getScrollPercent();

            //IF SCROLLED PAST 50% AND WE HAVE NOT FIRED YET
            /*ORIGINAL CODE TO ONLY FIRE loadNewsletterPromo();
        if(scrollPercentage>35 && firedNewsletterPromo==0){
          //load newsletter promo
          //alert('scroll-percentage: '+scrollPercentage);
          firedNewsletterPromo=1; //SET FIRE TRIGGER OFF
          loadNewsletterPromo();

        }*/

            //M.B. SEE CHANGE LOG ON TOP FILE...
            /*if(scrollPercentage>25 && firedNotificationsPromo==0){
          //load notifications promo
          //alert('scroll-percentage: '+scrollPercentage);
          firedNotificationsPromo=1; //SET FIRE TRIGGER OFF
          // Make sure OS is Mac, Windows, Android or Linux
          // Make sure browser is chrome or firefox

          //if(pop_up_notif){
            //loadNotificationsPromo();
          //}else{
            var newsPopCookie = readCookie('newsletterScrollPop');
            if(!newsPopCookie && SITE_INFO['name'] != 'politics'){
              loadNewsletterPromo();
            }
          //}

        }*/

            // Scroll Down
            if( (windowWidth < 1180 && $( 'body.home' ).length) || !$( 'body.home' ).length || !$("body.polls").length ){
                // console.log('scroll Down');
                $("#masthead-wrapper").removeClass("nav-down").addClass("nav-up");
            }

            if( $("body.polls").length ){

                $("#masthead-wrapper").removeClass("nav-up");
                $("#masthead-wrapper").removeClass("nav-down");
                $("#masthead-wrapper").css({"position" : "static !important"});
                $("#container").css({"padding-top" : "0 !important"});
                $("body").css({"margin" : "0 !important"});

                /*if( $("#masthead-wrapper").hasClass("nav-down") ){

                  $("#masthead-wrapper").mouseleave(function(){
                        setTimeout(function(){
                          $("#masthead-wrapper").removeClass("nav-down").addClass("nav-up");
                      }, 2000);
                    });

                  //if( $("#masthead-wrapper").not(":hover") ){
                      /*setTimeout(function(){
                          $("#masthead-wrapper").removeClass("nav-down").addClass("nav-up");
                      }, 2000); */
                //}

                //}

            }


            $("#masthead-wrapper").css({ "box-shadow" : "none" });


            /*if( windowWidth < 768 && st>navbarHeight){
          $("#masthead-container").removeClass("nav-down").addClass("nav-up").css("position","fixed");
        }*/

            if( windowWidth < 768 && !$( 'body.polls' ).length ){
                $("#masthead-container").removeClass("nav-down").addClass("nav-up").css("position","fixed");
            }


            $("#masthead-container").css({ "box-shadow" : "none" });


            $(".progress-bar").css({ "position" : "relative", "top" : "8px" });

            if( mastHeight == "54px" ){
                $("progress").css({ "position" : "relative", "top" : "-11px" });
            }

            if( mastHeight == "166px" && windowWidth <= 1280 ){
                $("progress").css({ "position" : "relative", "top" : "-14px" });
            }

            if( windowWidth >= 768 || windowWidth <= 1024 ){
                $(".progress-bar").css({ "position" : "fixed", "top" : "0" });
            }


            if(!$("body.polls").length){
                if(notif_banner_enabled){
                    $('#masthead-container').css('margin-top', '35px');
                    $('.flex-viewport').css('margin-top', '35px');
                    //to push the menu down on inner pages
                    if(!$("body").hasClass("home") && $('#large_notif_wrapper').is(':visible')){
                        $('#large_notif_wrapper').css('top', '0');
                        $('#masthead-wrapper').css('top', '35px');
                        $('#container').css('padding-top', '45px');
                        if($('#masthead-wrapper').hasClass('nav-down')){
                            if(windowWidth < 768){
                                $('.progress-bar').css('top', '89px');
                            }else{
                                $('.progress-bar').css('top', '110px');
                            }
                        }else{
                            $('.progress-bar').css('top', '35px');
                        }
                    }
                }else{
                    $('#masthead-container').css('margin-top', 'inherit');
                    $('.flex-viewport').css('margin-top', 'inherit');
                    $('#masthead-wrapper').css('top', '0');
                    $('#container').css('padding-top', '10px');
                }
            }

        } else {

            // Scroll Up
            // If did not scroll past the document (possible on mac)...

            if(st + $(window).height() < $(document).height()) {

                // doing a do while so it can break out early in the first if check
                do{

                    /**
                     * this is for distro scale on mobile to not show the mast head unless the user has scrolled to the top
                     * This will apply to all pages and ignore all other rules below
                     */
                    if( SITE_NAME == 'politics' && $(window).width() < 768  && window.pageYOffset > 100){
                        //console.log('scroll - else ');
                        $("#masthead-container").removeClass("nav-down").addClass("nav-up");
                        break;
                    }

                    if( (windowWidth < 1180 && $( 'body.home' ).length) || !$( 'body.home' ).length || !$("body.polls").length ){
                        $("#masthead-wrapper").removeClass("nav-up").addClass("nav-down");
                    }

                    if( $("body.polls").length ){

                        $("#masthead-wrapper").removeClass("nav-up");
                        $("#masthead-wrapper").removeClass("nav-down");
                        $("#masthead-wrapper").css({"position" : "static !important"});
                        $("#container").css({"padding-top" : "0 !important"});
                        $("body").css({"margin" : "0 !important"});

                        /*if( $("#masthead-wrapper").hasClass("nav-down") ){

                    $("#masthead-wrapper").mouseleave(function(){
                            setTimeout(function(){
                            $("#masthead-wrapper").removeClass("nav-down").addClass("nav-up");
                        }, 2000);
                        });

                    //if( $("#masthead-wrapper").not(":hover") ){
                        /*setTimeout(function(){
                            $("#masthead-wrapper").removeClass("nav-down").addClass("nav-up");
                        }, 2000); */
                        //}

                        //}

                    }

                    /*if( windowWidth < 1024 ){
                $("#masthead-container").removeClass("nav-up").addClass("nav-down");

                if( st<navbarHeight){ //GOING BACK UP IF WE PASS THE AD WE PUT THE MASTHEAD IN STARTING POSITION BELOW THE HEADER
                $("#masthead-container").css("position","inherit");
                }
            }*/

                    if( windowWidth < 768 && !$( 'body.polls' ).length ){
                        $("#masthead-container").removeClass("nav-up").addClass("nav-down");
                        //if( st<navbarHeight){
                        $("#masthead-container").css("position","fixed");
                        //}
                    }

                    $(".progress-bar").css({ "position" : "relative", "top" : "15px" });

                    if( windowWidth >= 768){
                        $(".progress-bar").css({ "position" : "fixed", "top" : "73px" });
                    }

                    if( windowWidth < 768){
                        if( SITE_INFO['name'] == "investigations" ){
                            $(".progress-bar").css({ "position" : "fixed", "top" : "42px" });
                        }else{
                            $(".progress-bar").css({ "position" : "fixed", "top" : "54px" });
                        }
                    }

                    if(!$("body.polls").length){
                        if(notif_banner_enabled){
                            $('#masthead-container').css('margin-top', '35px');
                            $('.flex-viewport').css('margin-top', '35px');
                            //to push the menu down on inner pages
                            if(!$("body").hasClass("home") && $('#large_notif_wrapper').is(':visible')){
                                $('#large_notif_wrapper').css('top', '0');
                                $('#masthead-wrapper').css('top', '35px');
                                $('#container').css('padding-top', '45px');
                                if($('#masthead-wrapper').hasClass('nav-down')){
                                    if(windowWidth < 768){
                                        $('.progress-bar').css('top', '89px');
                                    }else{
                                        $('.progress-bar').css('top', '110px');
                                    }
                                }else{
                                    $('.progress-bar').css('top', '35px');
                                }
                            }
                        }else{
                            $('#masthead-container').css('margin-top', 'inherit');
                            $('.flex-viewport').css('margin-top', 'inherit');
                            $('#masthead-wrapper').css('top', '0');
                            $('#container').css('padding-top', '10px');
                        }
                    }

                    //alert( mastHeight );
                    if( mastHeight == "54px" ){
                        $("#masthead-wrapper").css({ "box-shadow" : "none" });
                        $("progress").css({ "position" : "relative", "top" : "-16px" });
                    }else{

                        // Removed per Ivan
                        // $("#masthead-wrapper").css({ "box-shadow" : "0px 8px 5px -5px "+SITE_INFO['site_color'] });
                    }

                    if( mastheadContainerHeight == "54px" ){
                        $("#masthead-container").css({ "box-shadow" : "none" });
                        $("progress").css({ "position" : "relative", "top" : "-16px" });
                    }

                // purposely break out so it never loops but we can still exit the if statement early above
                }while(false);

            }

            if(st < 135){  //height of masthead-wrapper + pageheader div - clears shadow smoothly
                $("#masthead-wrapper").css({ "box-shadow" : "none" });
            }

        }

        lastScrollTop = st;
        didScroll = false;
    }
}

export default init_masthead_scroller;